import React from "react";
import { useOutletContext } from "react-router-dom";

import Unauthorized from "../../../ui/components/Unauthorized/Unauthorized";

import useHasRight from "../../../authorization/hooks/useHasRight";

import ProductionReadersView from "../../views/ProductionReadersView/ProductionReadersView";

export default function ProductionReaders() {
	const { offers, production } = useOutletContext();

	const hasRight = useHasRight();

	if (!hasRight("productions.manage")) {
		return <Unauthorized />;
	}

	return <ProductionReadersView offers={offers} production={production} />;
}
